import { useEffect, useState } from "react";

const COUNTDOWN_SECONDS = 5 * 60;

interface SmsResendProps {
  isResending: boolean;
  onResend: () => Promise<boolean>;
}

export default function SmsResend({ isResending, onResend }: SmsResendProps) {
  const [timeLeft, setTimeLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (timeLeft === 0) return;

    const timer = window.setTimeout(() => {
      setTimeLeft((current) => current - 1);
    }, 1000);

    return () => window.clearTimeout(timer);
  }, [timeLeft]);

  const handleResend = async () => {
    if (timeLeft > 0 || isResending) return;

    const isSuccess = await onResend();

    if (isSuccess) setTimeLeft(COUNTDOWN_SECONDS);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const formattedTime = `${minutes
    .toString()
    .padStart(2, "0")}：${seconds.toString().padStart(2, "0")}`;

  const canResend = timeLeft === 0 && !isResending;

  return (
    <div className="flex flex-col items-center">
      <button
        type="button"
        disabled={!canResend}
        onClick={handleResend}
        className={`
          text-[24px] font-bold leading-[48px]
          ${
            canResend ? "cursor-pointer text-black underline" : "text-[#9D9999]"
          }
        `}
      >
        {isResending ? "發送中..." : "重新發送驗證碼"}
      </button>

      {timeLeft > 0 ? (
        <span className="text-[24px] font-bold leading-[48px] text-black">
          （{formattedTime}）
        </span>
      ) : null}
    </div>
  );
}
